import { CoreRankingsTable } from '../../../views';
import { RankingsRow } from '../RankingsRow';

export class RankingsTable extends CoreRankingsTable {
	get className() {
		return 'team-rankings league-table shadow';
	}

	get childView() {
		return RankingsRow;
	}
}

export default RankingsTable;